import { render, staticRenderFns } from "./EditarAspectos.vue?vue&type=template&id=178dcd26&scoped=true&"
import script from "./EditarAspectos.vue?vue&type=script&lang=js&"
export * from "./EditarAspectos.vue?vue&type=script&lang=js&"
import style0 from "./EditarAspectos.vue?vue&type=style&index=0&id=178dcd26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178dcd26",
  null
  
)

export default component.exports